import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, TextField, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import { textFormat } from "utils/Utils";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import brandTheme from "brandTheme/Theme";
import SchemeCharge from "./SchemeCharges";
import ToastModal from "views/components/ToastModal";
const style = () => ({
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    "& .Mui-disabled": {
      color: brandTheme.fieldColor,
    },
    "& .MuiInputBase-input": {
      padding: "10px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
      },
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      top: "-7px",
      color: brandTheme.black,
      "@media (max-width:768px)": {
        fontSize: "13px",
      },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.black,
      top: "0px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      "& :hover": {
        borderColor: brandTheme.black,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
  },
  deleteButton: {
    position: "absolute",
    bottom: "15px",
    right: "-65px",
  },
  minAmountContainer: {
    position: "relative",
  },
  textInput: {
    marginBottom: "2%",
  },
});
const useStyles = makeStyles(style);
const SchemeCreate = ({
  selectedScheme,
  closeModal,
  classes,
  loanApplicationId,
  editable,
  enabledMinMAxPercentageFieldsCharges,
  enableMinAndAnnualInterestRate,
  // featureFlags
}) => {
  const navigate = useNavigate();
  const textfieldClass = useStyles();
  const [channel, setChannel] = useState("");
  const [codeData, setCode] = useState("");
  const code = codeData?.replace(/[^a-z0-9_]/gi, "");
  const [name, setName] = useState("");
  const [graceday, setGraceDay] = useState("");
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const [minLoanAmount, setMinLoanAmount] = useState("");
  const [ltv, setLtv] = useState("");
  const [interestRate, setInterestRate] = useState({});
  const [interestRateCount, setInterestRateCount] = useState(0);
  const [isActive, setIsActive] = useState("");
  const [rateMax, setRateMax] = useState("");
  const [tenure, setTenure] = useState("");
  const [frequency, setFrequency] = useState("");
  const [interestmissNotificationDays, setInterestmissNotificationDays] =
    useState("");
  const [interestdueNotificationDays, setInterestdueNotificationDays] =
    useState("");
  const [postMaturityInterestRate, setPostMaturityInterestRate] = useState("");
  const [compoundInterest, setCompoundInterest] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [lastIndex, setLastIndex] = useState(-1);
  const [groupDetails, setGroupDetails] = useState([]);
  const [insuranceApplicable, setInsuranceApplicable] = useState(false);
  const [crossCellEnable, setCrossCellEnable] = useState(false);
  const [crossCellPercentage, setCrossCellPercentage] = useState("");
  const [colendingPartnerData, setColendingPartnerData] = useState({});
  const [colendingEnable, setColendingEnable] = useState(false);
  const [minLtvValue, setMinLtvValue] = useState("");
  const [minLtvPercentageError, setMinLtvPercentageError] = useState(false);
  const [minAnnualInterestRate, setMinAnnualInterestRate] = useState("");
  const [minAnnualInterestRateError, setMinAnnualInterestRateError] =
    useState(false);
  // display find user
  useEffect(() => {
    if ((selectedScheme && editable) || !editable) {
      editScheme();
    }
  }, []);
  const editScheme = async () => {
    const url =
      editable && selectedScheme
        ? endpoint.ADMIN_LOANSCHEME_FIND + selectedScheme
        : endpoint.SCHEME_DETAILS_FIND + loanApplicationId;
    setCallInProgress(true);
    const result = await apiHandler({
      url: url,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setCode(result?.data?.code);
      setName(result?.data?.name);
      setChannel(textFormat(result?.data?.schemeChannel));
      setGraceDay(result?.data?.graceDays);
      setMaxLoanAmount(result?.data?.maxLoanAmount);
      setMinLoanAmount(result?.data?.minLoanAmount);
      setTenure(result?.data?.tenureInMonths);
      setLtv(result?.data?.ltvPercentage);
      setFrequency(textFormat(result?.data?.frequency));
      setInterestmissNotificationDays(
        result?.data?.interestmissNotificationDays
      );
      setInterestdueNotificationDays(result?.data?.interestdueNotificationDays);
      if (result?.data?.loanSchemeInterestRateMap) {
        const values = Object.values(result?.data?.loanSchemeInterestRateMap);
        setInterestRateCount(values.length - 1);
        setInterestRate(result?.data?.loanSchemeInterestRateMap);
      }
      setRateMax(result?.data?.annualInterestRateMax);
      setPostMaturityInterestRate(result?.data?.postMaturityAnnualInterestRate);
      setCompoundInterest(result?.data?.compoundInterestApplicable);
      setGroupDetails(result?.data?.schemeCharges);
      setLastIndex(result?.data?.schemeCharges?.length - 1);
      setIsActive(result?.data?.status === "ACTIVE" ? true : false);
      setInsuranceApplicable(result?.data?.data?.INSURANCE_APPLICABLE);
      setCrossCellEnable(result?.data?.data?.CROSS_SELL);
      setCrossCellPercentage(result?.data?.data?.CROSS_SELL_PERCENTAGE);
      setColendingPartnerData(result?.data?.coLending);
      setColendingEnable(result?.data?.data?.CO_LENDING);
      setMinLtvValue(result?.data?.miniLtvPercentage);
      setMinAnnualInterestRate(result?.data?.minimumAnnualInterestRate);
    }
  };

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const handleCancelUser = () => {
    closeModal();
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label="Loan Scheme"
            button1=" Cancel"
            button1click={handleCancelUser}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Name"
              required
              id="lp_branch_name"
              value={name || ""}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Code"
              required
              id="lp_branch_code"
              type="code"
              value={code?.toUpperCase() || ""}
              // maxLength="3"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Channel*"
              id="branch_channel"
              value={channel}
              type="channel"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Interest due frequency*"
              value={frequency}
              id="branch_interest_due"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Interest due Notification Days"
              required
              id="lp_Branch_interest_due_notification_days"
              value={interestdueNotificationDays?.replace(/\s/g, "")}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Interest miss Notification Days"
              required
              id="lp_branch_interest_missnotification_days"
              value={interestmissNotificationDays?.replace(/\s/g, "")}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Grace Day"
              required
              id="lp_branch_graceday"
              value={graceday === 0 ? "0" : graceday}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Ltv"
              required
              id="lp_branch_ltv"
              value={ltv === 0 ? "0" : ltv}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Min Loan Amount"
              required
              id="lp_branch_min_loan_amount"
              value={minLoanAmount === 0 ? "0" : minLoanAmount}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Max Loan Amount"
              required
              id="lp_branch_max_loan_amount"
              value={maxLoanAmount === 0 ? "0" : maxLoanAmount}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Tenure (in months)"
              required
              id="lp_branch_tenure"
              value={tenure}
              disabled={true}
            />
          </Grid>
          {!enableMinAndAnnualInterestRate && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Post Maturity interest rate*"
                required
                id="lp_branch_post_maturity_interest_rate"
                value={postMaturityInterestRate}
                disabled={true}
              />
            </Grid>
          )}
          {enableMinAndAnnualInterestRate && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Min Ltv Percentage"
                required
                error={minLtvPercentageError}
                id="min_loan_percetage"
                value={minLtvValue}
                setState={(e) => setMinLtvValue}
                setError={setMinLtvPercentageError}
                disabled={true}
              />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ textAlign: "left" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="select_all"
                type="checkbox"
                checked={compoundInterest}
                className={classes.checkboxInput}
                onChange={(e) => setCompoundInterest(e.target.checked)}
                disabled={true}
              />{" "}
              Compound Interest Applicable
            </span>
          </Grid>
          {selectedScheme && (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.fieldContaienr}
              style={{ textAlign: "left" }}
            >
              <p style={{ fontWeight: "bold", marginTop: "0" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isActive}
                  className={classes.checkboxInput}
                  disabled={true}
                />{" "}
                Active
              </p>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ textAlign: "left" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="select_all"
                type="checkbox"
                checked={insuranceApplicable}
                className={classes.checkboxInput}
                onChange={(e) => setInsuranceApplicable(e.target.checked)}
                disabled={true}
              />{" "}
              Insurance Applicable
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ textAlign: "left" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="select_all"
                type="checkbox"
                checked={colendingEnable}
                className={classes.checkboxInput}
                disabled
              />{" "}
              Co lending
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ textAlign: "left" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="select_all"
                type="checkbox"
                checked={crossCellEnable}
                className={classes.checkboxInput}
                disabled
              />{" "}
              Cross Sell
            </span>
          </Grid>
          {crossCellEnable && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Cross Sell Percentage*"
                required
                id="lp_branch_post_maturity_interest_rate"
                value={crossCellPercentage}
                disabled={true}
              />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ textAlign: "left" }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="select_all"
                type="checkbox"
                checked={colendingPartnerData?.enabled}
                className={classes.checkboxInput}
                disabled
              />{" "}
              CoLending Partner
            </span>
          </Grid>
          {colendingPartnerData?.enabled && (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Partner code"
                  required
                  id="lp_branch_post_maturity_interest_rate"
                  value={colendingPartnerData?.partnerCode}
                  disabled={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Partner Deal Code"
                  required
                  id="lp_branch_post_maturity_interest_rate"
                  value={colendingPartnerData?.partnerDealCode}
                  disabled={true}
                />
              </Grid>
            </>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.inputFieldContainer}
            style={{ display: "flex" }}
          >
            <h2 className={classes.header}>Annual Interest Rate</h2>
          </Grid>
          {enableMinAndAnnualInterestRate && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomTextField
                label="Min Annual Interest Rate"
                required
                error={minAnnualInterestRateError}
                id="min_annual_interest_rate"
                value={minAnnualInterestRate}
                setState={setMinAnnualInterestRate}
                setError={setMinAnnualInterestRateError}
                disabled={true}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Max"
              required
              id="lp_branch_max"
              value={rateMax}
              disabled={true}
            />
          </Grid>
          <Grid
            xs={12}
            sm={6}
            md={4}
            className={`${classes.fieldContaienr} ${classes.minAmountContainer}`}
            style={{ position: "relative" }}
          >
            {Array.apply(null, { length: interestRateCount + 1 }).map(
              (e, i) => (
                <div
                  key={i}
                  className={`${textfieldClass.textField} ${textfieldClass.textInput}`}
                >
                  <TextField
                    label={
                      i === 0
                        ? i * 30 + 0 + "-" + (i * 30 + 30) + " Days*"
                        : i * 30 + 1 + "-" + (i * 30 + 30) + " Days*"
                    }
                    InputLabelProps={{ shrink: true }}
                    id={"lp_rate_" + i}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    variant="outlined"
                    style={{
                      width: "100%",
                      marginBottom: "20px",
                    }}
                    value={interestRate[i + 1]}
                    onChange={(event) =>
                      setInterestRate({
                        ...interestRate,
                        [i + 1]: event.target.value,
                      })
                    }
                    type="number"
                    disabled={true}
                  />
                </div>
              )
            )}
          </Grid>
          {groupDetails?.length > 0 && (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.inputFieldContainer}
            >
              <SchemeCharge
                classes={classes}
                groupDetails={groupDetails}
                lastIndex={lastIndex}
                enabledMinMAxPercentageFieldsCharges={
                  enabledMinMAxPercentageFieldsCharges
                }
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </div>
  );
};
SchemeCreate.propTypes = {
  classes: PropTypes.object,
};
export default SchemeCreate;